module.exports = __webpack_public_path__ + "img/40_69_010_950.5be7138d.jpg";